(function () {

    'use strict';

    angular.module('Services').factory('RouteWaypointTable', RouteWaypointTable);
    RouteWaypointTable.$inject = [
        'FleetService',
        'Carrier',
        'TableLiteFactory',
        '$filter',
        'toastr',
        '$uibModal'
    ];
    function RouteWaypointTable(
        FleetService,
        Carrier,
        TableLiteFactory,
        $filter,
        toastr,
        $uibModal
    ) {
        return function (route) {
            function openWaypoint(waypoint, center) {
                const modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'full-height-modal',
                    templateUrl: '/templates/pages/fleets/modals/waypoint-details.html',
                    controller: 'WaypointDetailsController',
                    controllerAs: 'vm',
                    size: 'lg',
                    appendTo: $('body'),
                    backdrop: 'static',
                    resolve: {
                        waypoint: function () {
                            return waypoint;
                        },
                        route: function () {
                            return route;
                        },
                        center
                    }
                });

                modalInstance.result.then(function (data) {
                    sendRequest();
                }, function () {

                });
            }
            let tableData = {
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'ADD NEW',
                        tooltip: 'Click to add a new Waypoint',
                        disabled: true,
                        onClick: function () {
                            FleetService.Routes.getWaypoints(route.id, data=>{
                                if(!data.content[0]){
                                    openWaypoint({
                                        waypointId: `WAYPNT${tableData.totalItems + 1}`,
                                        name: `Waypoint ${tableData.totalItems + 1}`
                                    });
                                    return;
                                }
                                const {latitude, longitude} = data.content[0];
                                if(longitude && latitude){
                                    openWaypoint({
                                        waypointId: `WAYPNT${tableData.totalItems + 1}`,
                                        name: `Waypoint ${tableData.totalItems + 1}`,
                                        latitude,
                                        longitude
                                    });
                                    return null;
                                }
                                openWaypoint({
                                    waypointId: `WAYPNT${tableData.totalItems + 1}`,
                                    name: `Waypoint ${tableData.totalItems + 1}`
                                });
                            }, err=>{
                                openWaypoint({
                                    waypointId: `WAYPNT${route.totalItems + 1}`,
                                    name: `Waypoint ${route.totalItems + 1}`
                                });
                            }, {
                                type: 'BASE'
                            });
                        }
                    }, {
                        class: 'btn-default',
                        label: 'Route Overview',
                        disabled: true,
                        onClick: function () {
                            FleetService.Routes.getWaypoints(route.id, data=>{
                                if(!data.content[0]){
                                    openWaypoint(null, {});
                                    return;
                                }
                                const {latitude, longitude} = data.content[0];
                                if(longitude && latitude){
                                    openWaypoint(null, {latitude, longitude});
                                    return null;
                                }
                                openWaypoint(null, {});
                            }, err=>{
                                openWaypoint(null, {});
                            }, {
                                type: 'BASE'
                            });
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false
                },
                headers: [{
                    label: 'Waypoint ID',
                    viewName: 'waypointId',
                    filterName: 'waypointId',
                    filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Waypoint Name',
                    viewName: 'name',
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Waypoint Type',
                    viewName: 'type',
                    filterName: 'type',
                    filter: {
                        type: 'select2',
                        placeholder: 'Search',
                        class: 'table-input',
                        items: [{
                            value: 'BASE',
                            viewName: 'Base'
                        }, {
                            value: 'NODE',
                            viewName: 'Node'
                        }],
                        onSelect: function (header) {
                            const filter = {};
                            filter[header.filterName] = header.filter.model;
                            tableActions.sendRequest(filter);
                        },
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'GPS Longitude',
                    viewName: 'longitude',
                    filterName: 'longitude',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'GPS Latitude',
                    viewName: 'latitude',
                    filterName: 'latitude',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Status',
                    viewName: 'status',
                    filterName: 'active',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Active', 'Inactive'],
                        onSelect: function (header) {
                            var filter = {};

                            if (header.filter.model == 'Active') {
                                filter[header.filterName] = true;
                            } else {
                                filter[header.filterName] = false;
                            }
                            sendRequest(filter);
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }],
                data: [],
                extractTable: function (form) {

                },
                resetFilters: ()=>{
                    tableActions.resetFilters();
                },
                rowOnClick: row=>{
                    openWaypoint(row);
                },
                onInit: function () {
                    sendRequest({});
                }
            };
            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: FleetService.Routes.getWaypoints,
                    callbackFormat: ['id','success','error','filter'],
                    postRequestCallback: data => {
                        tableData.optionAddOns.buttons.forEach(btn=>btn.disabled = false);
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        tableData.optionAddOns.buttons.forEach(btn=>btn.disabled = false);
                        buildTableData(null);
                        toastr.error(err);
                    },
                    paramId: route.id,
                    defaultFilters: {
                        size: 20,
                        page: 0,
                        sort: 'createdDate,desc'
                    }
                }
            );

            function buildTableData(data) {
                /*** START - Building of Data ***/
                if (!data)
                    return tableData;
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    item.status = {
                        type: 'status',
                        status: item.active,
                        label: item.active ? 'Active' : 'Inactive'
                    };
                    tableData.data.push(item);
                });
            }

            function refreshTable() {
                sendRequest({});
            }

            function sendRequest(filters) {
                tableData.optionAddOns.buttons.forEach(btn=>btn.disabled = true);
                tableActions.sendRequest(filters);
            }
            this.tableData = tableData;
            this.refreshTable = refreshTable;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/routesTables/RouteWaypointTable.js